import { api, type Config, getRequestBody } from './api';

export async function patch<T>(url: string, data: any, config?: Config): Promise<T> {
  const body = getRequestBody(data);
  return api<T>(`${url}${config?.params ? `?${new URLSearchParams(config.params).toString()}` : ''}`, {
    ...(body && { body }),
    method: 'PATCH',
    headers: config?.headers ? { ...config.headers } : {}
  });
}
